import ObjectListWidget from '@plone/volto/components/manage/Widgets/ObjectListWidget';
import { normalizeItems } from './helper';

const ItemSchema = {
    title: 'Configurazione Footer Links',
    properties: {
        type: {
            description: "Seleziona il tipo tra email, link o statico",
            title: "Tipo oggetto",
            type: "string",
            choices: [
                ['email', 'Email'],
                ['link', 'Link'],
                ['statico', 'Statico'],
            ]
        },
        value: {
            description: "Inserisci la mail per tipo mail, il link per tipo link oppure il testo per tipo statico",
            title: "Valore",
            type: "string"
        },
        label: {
            description: "Label da mostrare, se non presente è uguale al Valore",
            title: "Label",
            type: "string"
        },
        abilitato: {
            description: "Abilita o Disabilita la visualizzazione della voce nei Footer Links",
            title: "Abilitato ?",
            type: "boolean"
        },
    },
    fieldsets: [
        {
            id: 'footer_links_config',
            title: 'Configurazione Footer Links',
            fields: [
                'type',
                'value',
                'abilitato',
                'label'
            ],
        },
    ],
    required: ['type', 'value'],
};

const FooterLinksWidget = (props) => {
    const items = normalizeItems(
        props.value?.items || props.default?.items || []
    );

    return (
        <ObjectListWidget
            schema={ItemSchema}
            {...props}
            value={items}
            onChange={(id, value) =>
                props.onChange(id, {
                    items: value.map(({ ['@id']: _, ...rest }) => rest),
                })
            }
        />
    );
};

export default FooterLinksWidget;